const FaqQuickLinks = () => {
  // Get all div elements with the class name 'faqs-accordion'
  const faqSections = document.querySelectorAll('.faqs-accordion');

  const ulElement = document.getElementById('faq-links');

  // Iterate through the sections and create links in the ul
  faqSections.forEach((section) => {
    const { id } = section;
    const name = id
      .replace(/-/g, ' ')
      .replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
    const listItem = document.createElement('li');
    listItem.classList.add('faqs-quick-links__item'); // Replace 'your-class-name' with the class you want to add
    const link = document.createElement('a');
    link.classList.add('faqs-quick-links__link'); // Replace 'your-class-name' with the class you want to add

    link.href = `#${id}`;
    link.textContent = name;

    listItem.appendChild(link);
    ulElement.appendChild(listItem);
  });
};

export default FaqQuickLinks;
